import { useState } from 'react';
import { getDocByID } from '../libs/firebase';

export function useProjectDataFetcher() {
    const [projectCache, setProjectCache] = useState(new Map());

    const fetchProjectData = async (projectId) => {
        // Check cache first
        if (projectCache.has(projectId)) {
            console.log('Using cached project data for:', projectId);
            return projectCache.get(projectId);
        }

        try {
            const doc = await getDocByID('projects', projectId);
            const projectData = doc.data();
            
            // Cache the data
            setProjectCache(prev => new Map(prev).set(projectId, projectData));
            
            return projectData;
        } catch (error) {
            console.error('Error fetching project data:', error);
            throw error;
        }
    };

    const clearCache = () => {
        setProjectCache(new Map());
    };

    return { fetchProjectData, clearCache };
}